const principles = [
  {
    icon: 'ri-emotion-laugh-line',
    title: '只做真搞笑',
    desc: '每一部作品都经编辑部试笑筛选，笑不出来不放行，拒绝尬笑硬凑。',
  },
  {
    icon: 'ri-refresh-line',
    title: '天天有更新',
    desc: '编辑团队每日两批上新热门搞笑条漫，追更从不让你等太久。',
  },
  {
    icon: 'ri-verified-badge-line',
    title: '追更不迷路',
    desc: '一键收藏、更新提醒、全平台适配，让你随时随地都能笑。',
  },
];

const contactItems = [
  { icon: 'ri-mail-line', label: '投稿与推荐', value: 'contribute@haha-comics.com' },
  { icon: 'ri-hand-heart-line', label: '商务合作', value: 'business@haha-comics.com' },
  { icon: 'ri-chat-smile-3-line', label: '用户反馈', value: 'support@haha-comics.com' },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20" aria-labelledby="about-title">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          {/* brand intro */}
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-user-heart-line" aria-hidden="true"></i>
              关于本站
            </span>
            <h2 id="about-title" className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              我们是哈哈漫画网
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              哈哈漫画网是一个专注分享搞笑漫画与爆笑漫画合集的内容平台。我们相信，生活已经够累了，每天能痛痛快快笑一场就是最好的解药。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              从校园、职场到家庭、萌宠，我们遍寻全网有趣好笑的条漫，精挑细选后呈现在你面前。每日更新、一键追更、全平台适配，只为让你笑到肚子疼也不迷路。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-lg text-primary-600">
                    <i className={p.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base text-foreground-950">{p.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* contact */}
          <div id="contact" className="scroll-mt-24">
            <div className="rounded-2xl border border-background-200 bg-background-100 p-5 md:p-7">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-xl text-background-50">
                  <i className="ri-customer-service-2-line" aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading text-lg text-foreground-950">联系我们 & 投稿</h3>
                  <p className="text-xs text-foreground-500">发现好笑的，别忘了分享给我们</p>
                </div>
              </div>

              <ul className="mt-5 flex flex-col gap-3">
                {contactItems.map((c) => (
                  <li
                    key={c.label}
                    className="flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 px-4 py-3"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-lg text-primary-600">
                      <i className={c.icon} aria-hidden="true"></i>
                    </span>
                    <span>
                      <span className="block text-xs text-foreground-500">{c.label}</span>
                      <span className="block text-sm font-medium text-foreground-900">{c.value}</span>
                    </span>
                  </li>
                ))}
              </ul>

              <p className="mt-5 flex items-start gap-2 rounded-xl bg-secondary-100 px-4 py-3 text-xs leading-relaxed text-secondary-800">
                <i className="ri-sparkling-line mt-0.5" aria-hidden="true"></i>
                温馨提示：投稿请注明作品名称与来源，经审核后会以你的署名推荐上线，让更多同好一起哈哈大笑。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}